export const statusOptions = [
  { key: 1, text: 'Draft', value: 'draft' },
  { key: 2, text: 'In Progress', value: 'in_progress' },
  { key: 3, text: 'Done', value: 'done' },
];

export const ORDER = 'created_at DESC';

export const TOAST_TIME = 3000;
